import React, {Component} from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import BGImage from '../Utilities/signinpage2.jpg'
import WarningDialog from './FunctionArea/WarningDialog'
import {server_ip} from '../ipAddress'


const wStyles = theme => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundImage: `url(${BGImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.type === 'dark' ? theme.palette.grey[900] : theme.palette.grey[50],
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  title:{
    fontSize:40,
    fontFamily:"Microsoft JhengHei"
  }
});

class SignInSide extends Component {
  constructor(props) {
      super(props)
      this.state= {
        userInputIdentification:{
        account:"",
        password:"",
      },
      failedTime:0,
      showWarningDialog:false
    }
  }

  Copyright=()=> {
    return (
      <Typography variant="body2" color="textSecondary" align="center">
        {'Copyright © GordonHsu 個人 Demo'}
        <Link color="inherit" href="https://www.google.com/">
         
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
    );
  }

  getAccount=(e)=>{
    this.setState({
      userInputIdentification:{
        account:e.target.value,
        password:this.state.userInputIdentification.password
      }
    })
  }

  getPassword=(e)=>{
    this.setState({
      userInputIdentification:{
        account:this.state.userInputIdentification.account,
        password:e.target.value
      }
    })
  }

  getValidation=async()=>{
    console.log("getValidation...")
    let validationResult = await fetch(server_ip+'/api/userValidation/validation',{
      method:'POST',
      headers:{
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({account:this.state.userInputIdentification.account, password:this.state.userInputIdentification.password})
    })

    let result = await validationResult.json()
    console.log("validation result : ")
    console.log(result[0])

    if(result[0])
    {
      let msg = {
        userID:result[0].User_SysID,
        userName:result[0].User_Name,
        userIP:result[0].User_IP
      }
      
      this.props.getValidation(msg)
      this.props.history.push("/dashboard")
    }
    else
    {
      if(this.state.failedTime>2)
      {
        this.setState({
          userInputIdentification:{
            account:null,
            password:null,
          },
          showWarningDialog:true,
          failedTime:0
        })
        this.account.value=null
        this.password.value=null
        //doing something to lock the validation failed account
      }
      else
      {
        this.setState({
          failedTime:this.state.failedTime+1
        })
      }
      
      console.log("validation failed !")
    }
  }
  
  handleClose=()=>{
    this.setState({
      showWarningDialog:false
    })
  }

  render(){

    const {classes} = this.props;
    //let warningNumber = {
    //  color:"#fc0313"
    //} 

  return (
    <Grid container component="main" className={classes.root}>
      <CssBaseline />
      <Grid item xs={false} sm={4} md={7} className={classes.image} />
      <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          <div className={classes.title}>
              華語電影資料庫
          </div>
          <div className={classes.title}>
              管理模組
          </div>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            使用者登入
          </Typography>
          <form className={classes.form} noValidate>
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="account"
              label="account"
              name="account"
              autoComplete="account"
              autoFocus
              inputRef={el=>{this.account=el}}
              
              onChange={this.getAccount}
            />
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              inputRef={el=>{this.password=el}}
              onChange={this.getPassword}
            />
            <FormControlLabel
              control={<Checkbox value="remember" color="primary" />}
              label="記住我的帳密"
            />
            <Button
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={this.getValidation}
            >
              登入
            </Button>
            <WarningDialog from={"SignIn"} showWarningDialog={this.state.showWarningDialog} confirm={this.handleClose} cancel={this.handleClose}/>
            <Grid container>
              <Grid item xs>
                <Link href="#" variant="body2">
                  忘記密碼?
                </Link>
              </Grid>
            </Grid>
            <Box mt={5}>
              {
                this.Copyright()
              }
            </Box>
          </form>
        </div>
      </Grid>
    </Grid>
  );
}
}

export default withStyles(wStyles)(SignInSide)